"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = require("graphql-tag");
const Environment_1 = require("../Environment");
const handleError_1 = require("../Environment/handleError");
exports.createCampaignExport = (keyword, status, triggerType) => (dispatch, getState) => {
    dispatch({ type: 'CREATE_CAMPAIGN_EXPORT_REQUEST' });
    const query = graphql_tag_1.default `
            mutation CreateCampaignExport(
                $keyword: String!
                $statuses: [CampaignStatus!]
                $triggerTypes: [CampaignTriggerType!]
            ) {
                campaignExportCreate(keyword: $keyword, statuses: $statuses, triggerTypes: $triggerTypes) {
                    id
                    URL
                    error
                    done
                }
            }
        `;
    let statuses = [];
    let triggerTypes = [];
    if (status) {
        statuses = [status];
    }
    if (triggerType) {
        triggerTypes = [triggerType];
    }
    const request = {
        query,
        variables: {
            keyword,
            statuses,
            triggerTypes,
        },
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        return new Promise((resolve) => {
            if (errors) {
                handleError_1.default('CREATE_CAMPAIGN_EXPORT_FAILURE', dispatch, errors[0].message);
                return resolve();
            }
            else {
                dispatch({
                    type: 'CREATE_CAMPAIGN_EXPORT_SUCCESS',
                    campaignExport: data.campaignExportCreate,
                });
                return resolve();
            }
        });
    }, ({ result }) => handleError_1.default('CREATE_CAMPAIGN_EXPORT_FAILURE', dispatch, result.errors[0].message));
};
exports.fetchCampaignExport = (id) => (dispatch, getState) => {
    dispatch({ type: 'FETCH_CAMPAIGN_EXPORT_REQUEST' });
    const query = graphql_tag_1.default `
            query FetchCampaignExport($id: ID!) {
                campaignExport(id: $id) {
                    id
                    URL
                    done
                    error
                }
            }
        `;
    const request = {
        query,
        variables: {
            id,
        },
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        return new Promise((resolve) => {
            if (errors) {
                handleError_1.default('FETCH_CAMPAIGN_EXPORT_FAILURE', dispatch, errors[0].message);
                return resolve();
            }
            else {
                dispatch({
                    type: 'FETCH_CAMPAIGN_EXPORT_SUCCESS',
                    campaignExport: data.campaignExport,
                });
                return resolve();
            }
        });
    }, ({ result }) => handleError_1.default('FETCH_CAMPAIGN_EXPORT_FAILURE', dispatch, result.errors[0].message));
};
